import React from "react";
import Header from "../sections/Header";
import Footer from "../sections/Footer";
import Adsterra from "./Adsterra";

const Layout = ({ children }) => {
  const headerHeight = 80;

  return (
    <div className="work-sans flex flex-col min-h-screen  max-sm:overflow-hidden">
      <Header headerHeight={headerHeight} />
      <div
        className="h-[60px] w-[468px] bg-ad mx-auto mb-3"
        style={{ marginTop: headerHeight + 24 + 12 }}
      >
        <Adsterra
          slot="406b055f29f582776ca5cfb3cb8da16d"
          headerHeight={headerHeight}
          isBelowHeader={true}
        />
      </div>

      <main className="flex-grow max-w-[1264px] m-auto p-normal ">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
